/**
 * Auth-drawer hash targets + parser. Extracted from account-drawer.tsx
 * (COM-189 wave 4) because the layout needs the SAME predicate to decide
 * whether to mount the (now lazy) drawer immediately on a hash landing —
 * without importing the drawer's heavy module graph into the layout chunk.
 *
 * URLSearchParams on both ends: producers (register loader,
 * requireAccountUser) encode `redirectTo` with it, so decode with it too.
 */
export type DrawerHashTarget =
  | "login"
  | "register"
  | "checkout-login"
  | "checkout-password"
  | "checkout-password-email"
  | "forgot-password";

export function parseDrawerHash(
  hash: string,
): { target: DrawerHashTarget; redirectTo: string } | null {
  const raw = hash.startsWith("#") ? hash.slice(1) : hash;
  const [target, query = ""] = raw.split("?");
  if (
    target !== "login" &&
    target !== "register" &&
    target !== "checkout-login" &&
    target !== "checkout-password" &&
    target !== "checkout-password-email" &&
    target !== "forgot-password"
  ) {
    return null;
  }

  return {
    target,
    redirectTo: new URLSearchParams(query).get("redirectTo") ?? "",
  };
}
